import { createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_FULL } from "@/utils/routes";

import { PrpScriptWithAccessGuard } from "./components/script-tool";

export const Route = createFileRoute(APP_ROUTES_FULL.PRP_SCRIPT)({
    component: PrpScriptWithAccessGuard,
});
